import { Link, GlobeIcon, GroupsIcon } from '@hypothesis/frontend-shared';
import classnames from 'classnames';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
/**
 * Render information about what group an annotation is in.
 */
export default function AnnotationGroupInfo(_ref) {
  var group = _ref.group;
  // Only show the name of the group and link to it if there is a
  // URL (link) returned by the API for this group. Some groups do not have links
  var linkToGroup = group === null || group === void 0 ? void 0 : group.links.html;
  return _jsx(_Fragment, {
    children: group && linkToGroup && _jsx(Link
    // The light-text hover color is not a standard color for a Link, so
    // a custom variant is used
    , {
      classes: classnames('text-color-text-light hover:text-color-text-light'),
      href: group.links.html,
      target: "_blank",
      underline: "hover",
      variant: "custom",
      children: _jsxs("div", {
        className: "flex items-baseline gap-x-1",
        children: [group.type === 'open' ? _jsx(GlobeIcon, {
          className: "w-2.5 h-2.5"
        }) : _jsx(GroupsIcon, {
          className: "w-2.5 h-2.5"
        }), _jsx("span", {
          children: group.name
        })]
      })
    })
  });
}
//# sourceMappingURL=AnnotationGroupInfo.js.map